const portfolio = {
  // Resume : Contain Information Regarding Resume Page, all the static reside here, modification here will reflect on the website
  resume: {
    projects: {
      title: "PROJECTS",
      list: [
        {
          title: "FAIL TaLMS (ACL Publication): Benchmarking Failures in Tool-Augmented Language Models",
          description: "Spearheaded the conception, development, and evaluation of the FAIL TALMS benchmark to expose and mitigate real-world failures in tool-augmented language models (LLM Agents: GPT4o, Llama (7B, 70B, 405B), Qwen72B, Claude3.5). Engineered novel failure-awareness metrics, validated over 900+ real-world APIs, and constructed 1,700+ diverse test scenarios targeting complex interactions and edge cases. Introduced and tested a human-in-the-loop tool (AAH) to enhance robustness against underspecified queries and tool execution failures."
        },
        {
          title: "Cybrecruiter: AI-Driven Hiring in Real Time",
          description: "Founded, designed, and engineered an end-to-end, AI-driven recruiting platform leveraging AWS serverless architecture (Lambda, Amplify, S3, Cognito, etc.) and CI/CD practices. Integrated real-time audio streaming, WhisperX for transcription, and a mixture of large language models (GPT-4o, Gemini, Claude) for dynamic interview analysis, reasoning, and task automation. Managed the complete product lifecycle from ideation to beta deployment (N=8 recruiters). Initial validation showed >80% expert acceptance on LLM-generated assessments and potential efficiency gains of 15-25 minutes per screening"
        },
        {
          title: "Real-Time Conversational AI Phone Agent", // Added this project
          description: "Designed, engineered, and deployed a production-grade, real-time speech-to-speech conversational AI agent utilizing Twilio, GPT-4o (Realtime), WhisperX ASR, and autoregressive TTS. Architected for natural interaction with low-latency components (<150ms VAD, F1=0.94 interruption detection) and adaptive turn-taking logic. Integrated function-calling LLMs for live NLU and task fulfillment (e.g., calendar, CRM access). Managed the full development lifecycle, including logging and analysis of 2,300+ calls across 30 beta users and conducting A/B testing on voice persona/prosody, resulting in a +18 NPS score increase and a 27% reduction in interaction latency."
        },
        {
          title: "Virtual Reactor: First-Ever Digital Twin of a Nuclear Microreactor",
          description: "Engineered the first-ever digital twin of the AGN-201 reactor by converting raw analog data into real-time digital data (NI DAQ, Jester, DeepLynx) and rendering a viewable asset in VR. Developed a multi-model ML pipeline (MLP, GrowNet, XGBoost) in a Linux HPC environment for predictive monitoring, forecasting power channels/control rods, achieving R²=0.93 in power-level predictions."
        },
        {
          title: "Nationwide Substation Scanning: Satellite-Powered Infrastructure Insights",
          description: "Autonomously inventoried U.S. substation components via an aerial imagery pipeline ingesting 0.5–2 m/pixel data (Sentinel 1/2, NAIP, Landsat 8/9) at 1.1–3 day intervals. Leveraged YOLOv8 to identify bounding boxes for 56,789 above-ground power substations. Curated 300M+ semantic labels from OpenStreetMap, Satlas, and INL’s AHA across 137 critical infrastructure types. Deployed a custom annotation tool for labeling 8 substation components, enabling robust training/evaluation on MaskDino, Swin ViT, ONE PEACE, and more—achieving up to 98% accuracy for large transformer segmentation."
        },
        {
          title: "Proliferation Detection: Red vs. Blue Experiments in Nuclear Reactors",
          description: "Led a red vs. blue team real-world experiment detecting proliferation events in the AGN-201 Reactor—e.g., inserting polyethylene rods, cadmium foil, removing graphite blocks—comparing a physics-based Gaussian Process Regression method and a machine learning approach (Isolation Forest). Achieved 99% anomaly detection accuracy during critical stages with an ensemble model."
        },
        {
          title: "Decomposing Robotics: Context-Aware Demonstrations for Code as Policies",
          description: "Built a context-aware demonstration decomposition evaluation for Code as Policies in RL Bench, employing large VLMs (Gemini 1.5 Flash, GPT4o) to generate fine-grained, frame-by-frame annotations. Incorporated YOLOv8 and MiDaS to capture gripper velocity, acceleration, and states—improving decomposition accuracy from ~62% to ~98%. Developed an interactive annotation tool for scalable, in-distribution data generation for imitation learning in embodied robotics."
        },
        {
          title: "Infrastructure LLM: Tool-Augmented Real-Time Analysis Agent",
          description: "Conducted a 45–90 minute think-aloud CTA with 8 expert critical infrastructure analysts, translating workflows into an LLM agent architecture. Developed a ground-truth trajectory set mirroring expert actions and enabled dynamic tool usage (aerial imagery labels, RSS feeds, RAG from 8,731 PDF docs, GPT4o image text tool, date/time, calculator, coordinate converter). Empowered site personnel with real-time guidance on infrastructure status, materials, and damage mitigation."
        },
        {
          title: "Financial AI: GPT4o Agent for Budget Control & Forecasting",
          description: "Performed a contextual inquiry CTA with 3 financial experts managing ~$1.55B in lab projects. Created a robust LLM agent evaluation set mirroring expert SQL queries, calculators, and analytical workflows. Deployed a Dockerized Django-based LLM agent incorporating efficient RAG (Stella embeddings, ChromaDB) over 100M+ Oracle SQL database rows. System currently serves 145+ internal users, significantly reducing turnaround times for complex, real-time fiscal queries and forecasting tasks."
        },
        {
          title: "Nuclear Imagery Pipeline: GAN-Boosted Reactor Classification",
          description: "Developed an automated pipeline aggregating 31GB of nadir imagery (Maxar Goldeye 1, WorldView 2/3) every 21 days across 10 reactor types (BWR, FBR, GCR, HTGR, HWGCR, HWLWR, LWGR, PHWR, PWR, X Energy). Trained an alias-free GAN to generate synthetic imagery, boosting DenseNet161’s reactor classification accuracy by 14%."
        },
        {
          title: "TRUEX Digital Twin: Rapid Anomaly Detection",
          description: "Developed a digital twin to monitor a TRUEX Extraction Process, detecting anomalies in 21 seconds—significantly faster than conventional optical spectroscopy’s 144-second response."
        },
        {
          title: "Adaptive LLM Learning: Think-Aloud Prompt Engineering",
          description: "Conducted a think-aloud CTA with 2 prompt engineering experts (8–17 minutes each) to extract key knowledge components via the KLI framework. Used insights to build an adaptive, LLM-driven learning experience. Ran an A/B test on 35 participants (treatment vs. control) showing significant improvement (p=0.008 via t test, p=0.017 via ANOVA; t stat 2.89, f stat 5.67) in learning outcomes."
        },
      // Multi-Modal VR Motion Planning (Undergraduate Capstone)
      {
        title: "Multi-Modal VR Motion Planning for Robotics",
        description: `
        For my undergraduate capstone, I developed a VR-based interface working alongside Dr. John Quarles that let users guide a virtual robot arm in real-time, collecting motion paths. Mapped these motion paths to a physical robotic arm using inverse kinematics. Incorporated Unity (C#), ROS, and Python, enabling an intuitive VR environment for robotics training data.
        `,
      },
      // NLP Graph Summarizer (University of Michigan Internship)
      {
        title: "NLP Graph Summarizer for 10k+ Nodes",
        description: `
        Led a research intern team exploring graph-based text summarization for 10,000+ nodes. Devised a custom Graph Neural Network to cluster text embeddings, improving summarization coherence by ~6%. Integrated RNNs for sequential context and built the pipeline in Python with PyTorch and NetworkX.
        `,
      },

      // LevelUp (Hackathon VR Face-to-3D)
      {
        title: "LevelUp (Hackathon VR Face-to-3D Converter)",
        description: `
        Won a 24-hour hackathon by building a VR tool that automatically converts a user’s 2D selfie into a playable 3D avatar. Implemented a Face-2-Mesh ML algorithm for facial geometry plus Facebook’s PITUF-3D for body proportions. Deployed a full-stack prototype with Unity (C#), React.js, Firebase, MongoDB, and Python for back-end data processing.
        `,
      },

      // Blockchain Currency Ecosystem (Hackathon)
      {
        title: "Blockchain Currency Ecosystem",
        description: `
        Created an ERC-20 token with ERC-721 support in under 24 hours for a hackathon. Deployed the token to multiple faucets across 300k+ mirror nodes, enabling an experimental tokenomics model. Utilized Solidity, React.js, React Native, Truffle, Ganache, and Firebase to provide real-time wallet balances and transactions for 2.5M potential users.
        `,
      },

      //  Minecraft Server & Modded Community (Early Project)
      {
        title: "Minecraft Server & Modded Community (Early AI & Dev Roots)",
        description: `
        At age 12, launched a Minecraft server that grew from 10 friends to over 7,000 active members. Developed custom plugins (Java) and set up router port-forwarding, community forums, plus an in-game economy. This early experience sparked my fascination with distributed systems, user engagement, and the power of code to bring people together.
        `,
      },
    ],
  },
    info: {
      title: "INFO",
      name: "Eduardo Treviño",
      age: ", Active Q Security Clearance",
      list: [
        ["Native - ", "English, Spanish"],
        ["Email - ", "eatrevin@cs.cmu.edu, realeddietrevino@gmail.com"],
        ["LinkedIn - ", "@eduardo-trevino"],
        ["Github - ", "@EduardoTrevino"],
        ["Medium - ", "@eduardotrevino"],
        ["Google Scholar - ", "@Eduardo Treviño"],
      ],
    },
    education: {
      title: "EDUCATION",
      list: [
        {
          company: " Pittsburgh, PA",
          course: "M.S. Computer Science - Artificial Intelligence",
          range: "Anticipated: Spring 2025 Carnegie Mellon University",
        },
        {
          company: " San Antonio, TX",
          course: "Bachelor of Science B.S. - Artificial Intelligence",
          range: "University of Texas at San Antonio ",
        },
      ],
    },
    experience: {
      title: "EXPERIENCE",
      list: [
        {
          // This is current, so it should be first or near the top.
          range: "2024 : Present - ", // Assuming start date, adjust if needed
          company: "Cybrecruiter, Pittsburgh, PA",
          title: "Founder & CEO",
          description: `
            Founded and led the end-to-end design, development, and deployment of Cybrecruiter, an AI-powered conversational recruiting platform. Architected and implemented a full-stack solution leveraging AWS serverless technologies (Lambda, Amplify, S3, Cognito, Route53) and CI/CD pipelines. Integrated real-time audio processing, advanced ASR (WhisperX), and multiple large language models (GPT-4o, Gemini, Claude) for sophisticated interview analysis, candidate assessment, and task automation. Managed the complete product lifecycle, including user research, prototyping, validation testing (achieving >80% expert acceptance on LLM outputs), and beta deployment (N=8 recruiters), demonstrating potential for significant efficiency gains (15-25 min/screening).
          `,
        },
        {
          range: "2022 : Present - ",
          company: "Idaho National Laboratory, Idaho Falls, ID",
          title: "AI Research Engineer",
          description: `
           Led the architecture, development, and deployment of large-scale AI/ML systems for mission-critical applications. Directed initiatives in LLM agents for infrastructure/financial analysis ($1.55B portfolio), computer vision pipelines for asset monitoring (300M+ labels), generative AI (GANs) for data augmentation (+14% accuracy), predictive digital twins (R²≈0.93) for operational optimization, and adversarial ML for enhanced system reliability (99% detection). Managed end-to-end project lifecycles using MLOps principles (Docker, CI/CD) across HPC and cloud platforms. Presented findings to senior leadership, contributing to strategic, data-driven decisions.
          `,
        },
        {
          range: "2021 : 2023 - ",
          company: "University of Michigan, Ann Arbor, MI",
          title: "Machine Learning Research Lead",
          description: `
            Led a research initiative applying deep learning to large-scale NLP challenges. Developed and trained large language models (up to 18B parameters) and designed custom Graph Neural Network architectures for text analysis and summarization (>10,000 nodes), improving performance by ~6%. Iterated on prototypes and refined integrated pipelines, bridging advanced algorithms with real-world NLP applications and collaborating with a team of 10+ researchers.
          `,
        },
        {
          range: "2019 : 2022 - ",
          company: "University of Texas at San Antonio, San Antonio, TX",
          title: "Machine Learning Research Assistant",
          description: `
            Developed automation solutions using various tools for data analytics within audit and consulting contexts, focusing on evaluating cybersecurity systems, risks, and controls. Created metric-driven data visualizations (40+) and presented findings on risk deployment processes. Assisted in developing and deploying large-scale data-driven methods for cybersecurity assessment tasks.
          `,
        },
        {
          range: "2019 : 2021 - ",
          company: "U.S. Census, San Antonio, TX",
          title: "Data Science",
          description: `
            Collected and performed statistical analysis on large-scale demographic survey data (30+ questions, 250+ data points/household). Developed reports and visualizations contributing to the strategic allocation of ~$10 million in federal funds based on socioeconomic needs. Collaborated with cross-functional teams to ensure data quality and guide evidence-based policy decisions.
          `,
        },
      ],
    },
    bio: {
      title: "BIO",
      description: `
        I’m a graduate at Carnegie Mellon University, dedicated to exploring how advanced AI systems can preserve human consciousness and foster continuous knowledge expansion. My journey began with early coding pursuits at age twelve, evolving into a robust focus on multi-modal AI pipelines, embodied AI robotics, HPC systems, digital twins, classified public-sector work, and large-scale LLM tool usage.

        My guiding principles center on safeguarding the essence of human awareness, capturing our collective perspectives, and ensuring we continually innovate and refine our knowledge base. These ideals shape every project I undertake, whether I'm automating nuclear microreactor monitoring, designing novel retrieval-augmented LLM agents, or championing user-centric approaches to AI product development.

        Beyond research, I engage deeply with entrepreneurship, exemplified by my founding of Cybrecruiter—an end-to-end AI recruiting platform that merges, cognitive science AI design, and real-time data processing. This synergy of advanced engineering, domain expertise, and human empathy underscores my broader commitment to building AI solutions that authentically serve humanity. I believe in bridging technological innovation with meaningful real-world impact, and I do so with unwavering passion! 
      `,
    },
    skills: {
      title: "SKILLS",
      list: [
        // AI & Machine Learning Technologies
        "PyTorch",
        "Scikit-Learn",
        "Python",
        "Pandas",
        "Numpy",
        "TypeScript",
        "JavaScript",
        "C/C++",

        "LangChain",
        "Llama Index",
        "Retrieval Augmented Generation (RAG)",
        "Embeddings",
        "Stable Diffusion",
        "GANs",
        "Large Language Models (LLMs)",
        "Reinforcement Learning",
        "Isaac Gym",
        "Cognitive Task Analysis",
        
        "Jax",
        "Tensorflow",
        "Keras",
        // Cloud Platforms & DevOps
        "AWS (EC2, S3, Amplify, Cognito, Elastic Beanstalk, CloudWatch, Route 53)",
        "Azure",
        "Heroku",
        "Vercel",
        // Databases & Systems
        "MongoDB",
        "PostgreSQL",
        "DynamoDB",
        "Linux",

        "Matplotlib",
        "Seaborn",
        "Plotly",
        "tidyquant",
    
        // Programming Languages & Frameworks

        "R",
        "C#",
        "Java",
        "Node.js",

    
        // Frontend & Mobile Development
        "React",
        "Next.js",
        "Expo",
        "CSS",
    
        // Game & Simulation Development
        "Unity",
        "UnrealEngine",
        "Blender",
        "Solidty (Ethereum)",
    
        // Real-Time Communication & Multimedia
        "WebRTC",
        "FFMPEG",
    
        // Development Methodologies & Tools
        "AI Product Design",
        "Project Management",
        "A/B Testing",
        "Evidence-Based Design",
        "OLI",
        "Prolific"
      ]
    },
    title: "Artificial Intelligence Research Engineer",
  },
  // Layout : Contain Information Regarding Layout of the Pages, all the static reside here, modification here will reflect on the website
  layout: {
    right: [
      {
        url: "/resume",
        label: "Resume",
        link: true,
      },
      {
        url: "mailto:realeddietrevino@gmail.com",
        label: "Email",
        link: false,
      },
      {
        url: "https://medium.com/@eduardotrevino",
        label: "Blogs",
      },
      {
        url: "https://github.com/EduardoTrevino",
        label: "GitHub",
      },
      {
        url: "https://www.linkedin.com/in/eduardo-trevino/",
        label: "LinkedIn",
      },
    ],
    left: [
      {
        url: "/about-me",
        label: "About",
      },
      {
        url: "/contact-me",
        label: "Contact",
      },
      {
        url: "/projects",
        label: "Projects",
      },
      {
        url: "/",
        label: "Home",
      },
    ],
  },

  // Contact : Contain Information Regarding Contact Page, all the static reside here, modification here will reflect on the website
  contact: {
    helmet: {
      title: "Eduardo Treviño - Contact Me",
    },
    title: "GET IN TOUCH 🏃",
    description:
      "I am currently in Pittsburgh, Pennsylvania, if you're nearby I'd love to grab some coffee! Otherwise feel free to send me an email if you have a question or just want to say hi ",
    btn: {
      url: "mailto:realerealeddietrevino@gmail.com",
      label: "Say Hi 👋 If you're in town!",
      link: false,
    },
    ending: "Or email me directly at realeddietrevino@gmail.com",
  },

  // About : Contain Information Regarding About Page, all the static reside here, modification here will reflect on the website
  About: {
    helmet: {
      title: "About Eduardo Treviño",
    },
    title: "Biography",
    social: {
      label: "🏃 Follow me on ",
      links: [
        { label: "Twitter", url: "https://twitter.com/EddieTrevinoo" },
        { label: "Linkedin", url: "https://www.linkedin.com/in/eduardo-trevino/" },
        { label: "GitHub", url: "https://github.com/EduardoTrevino" },
        { label: "Medium", url: "https://eduardotrevino.medium.com/" },
        { label: "Google Scholar", url: "https://scholar.google.com.au/citations?user=dKnDrUgAAAAJ" }
      ],
    },
    description: [
      `I'm a bilingual AI research engineer from a unique border-town upbringing who truly enjoys bridging the gap between AI and real-world impact.`,
      `Beyond coding, I’m a philosopher at heart, driven by the belief that we must preserve human consciousness, capture human worldviews, and ensure continuous advancement of knowledge.`,
    ],
  },

  // Home : Contain Information Regarding Home Page, all the static reside here, modification here will reflect on the website
  home: {
    showModel: true,
    helmet: {
      title: "Eduardo Treviño - Welcome to my Research and Projects!",
    },
    title: ["Eduardo", "Treviño"],
    subTitle: "Artificial Intelligence Research Engineer",
    description: `Welcome to my portfolio! Get to know my work where advanced AI meet's real-world application, and scientific breakthrough!`,
  },
  
  // Projects : Contain Information Regarding Projects Page, all the static reside here, modification here will reflect on the website
  projects: [
    {
      technology: ["Python", "PyTorch", "Scikit-Learn", "LangChain", "Large Language Models (LLMs)"],
      slug: "projects/fail-talms",
      title: "FAIL TALMS: Benchmarking Real-World LLM Agent Failures",
      description: "Spearheaded the conception, development, and evaluation of the FAIL TALMS benchmark to expose and mitigate real-world failures in tool-augmented language models (LLM Agents). Designed novel failure-awareness metrics, validated over 900+ real-world APIs, and constructed 1,700+ diverse test scenarios. Introduced and tested a human-in-the-loop tool (AAH) to tackle edge cases such as underspecified queries and unavailable tools.",
      image: "/TaLms.png",
      link: [
        { text: "Github", url: "https://github.com/EduardoTrevino/Fail-TaLMs" },
        { text: "ACL Publication Paper", url: "https://github.com/EduardoTrevino/Fail-TaLMs/blob/main/assets/Benchmarking_Failures_in_Tool-Augmented_Language_Models_Paper.pdf" },
        { text: "ACL Publication Poster", url: "https://github.com/EduardoTrevino/Fail-TaLMs/blob/main/assets/Benchmarking_Failures_in_Tool-Augmented_Language_Models_Poster.pdf" }
      ],
    },
    {
      technology: ["Python", "Scikit-Learn", "Linux"],
      slug: "projects/virtual-reactor",
      title: "Virtual Reactor: First-Ever Digital Twin of a Nuclear Microreactor",
      description: "Built the first-ever digital twin of the AGN-201 reactor by converting raw analog data into real-time digital data (NI DAQ, Jester, DeepLynx) and rendering a viewable asset in VR. Developed a multi-model ML pipeline (MLP, GrowNet, XGBoost) in a Linux HPC environment for forecasting power channels/control rods, achieving R²=0.93 in power-level predictions.",
      image: "/digitaltwin.jpg",
      link: [
        { text: "Elsevier Publication", url: "https://www.sciencedirect.com/science/article/pii/S0306454924007047" },
        { text: "INMM Publication", url: "https://resources.inmm.org/sites/default/files/2023-07/finalpaper_209_0513112751.pdf" },
        { text: "World-Nuclear-News", url: "https://www.world-nuclear-news.org/Articles/Idaho-researchers-develop-reactor-digital-twin" },
        { text: "NEI Magazine)", url: "https://www.neimagazine.com/news/newsus-researchers-develop-nuclear-reactor-digital-twin-11426524" },
        // { text: "Media 3 (ScienceSprings)", url: "https://sciencesprings.wordpress.com/2023/12/19/from-the-does-idaho-national-laboratory-going-digital-idaho-students-and-engineers-demonstrate-first-nuclear-reactor-digital-twin/" },
        // { text: "Media 4 (ChinaDaily)", url: "https://subsites.chinadaily.com.cn/cnnc/2024-01/04/c_954390.htm" },
        { text: "Power-Eng", url: "https://www.power-eng.com/news/first-digital-twin-of-a-nuclear-reactor/#gref" },
        { text: "NuclearStreet", url: "https://nuclearstreet.com/pro_nuclear_power_blogs/b/world_nuclear_news/archive/2024/01/04/idaho-researchers-develop-reactor-digital-twin" },
        // { text: "Media 7 (Inside.com)", url: "https://inside.com/metaverse/posts/idaho-national-laboratory-and-isu-develop-world-s-first-nuclear-reactor-digital-twin-406722" },
        // { text: "Media 8 (Ground.News)", url: "https://ground.news/article/idaho-researchers-develop-reactor-digital-twin-new-nuclear-world-nuclear-news" }
      ],
    },
    {
      technology: ["Python", "PyTorch", "Scikit-Learn", "Linux"],
      slug: "projects/nationwide-substation-scanning",
      title: "Nationwide Substation Scanning: Satellite-Powered Infrastructure Insights",
      description: "Autonomously inventoried U.S. substation components via an aerial imagery pipeline ingesting 0.5–2 m/pixel data (Sentinel 1/2, NAIP, Landsat 8/9) at 1.1–3 day intervals. Leveraged YOLOv8 to identify bounding boxes for 56,789 above-ground power substations. Curated 300M+ semantic labels from OpenStreetMap, Satlas, and INL’s AHA across 137 critical infrastructure types. Deployed a custom annotation tool for labeling 8 substation components, enabling robust training/evaluation on MaskDino, Swin ViT, ONE PEACE, and more—achieving up to 98% accuracy for large transformer segmentation.",
      image: "/satlas.png",
      link: [
        { text: "Github", url: "https://github.com/EduardoTrevino/Under_Export_Control" }
      ],
    },
    {
      technology: ["Python", "Scikit-Learn", "Linux"],
      slug: "projects/proliferation-detection",
      title: "Proliferation Detection: Red vs. Blue Experiments in Nuclear Reactors",
      description: "Led a red vs. blue team real-world experiment detecting proliferation events in the AGN-201 Reactor—e.g., inserting polyethylene rods, cadmium foil, removing graphite blocks—comparing a physics-based Gaussian Process Regression method and a machine learning approach (Isolation Forest). Achieved 99% anomaly detection accuracy during critical stages with an ensemble model.",
      image: "/ADdigitaltwin.png",
      link: [
        { text: "Elsevier Paper", url: "https://www.sciencedirect.com/science/article/pii/S0306454924006534" },
        { text: "Harvard Link", url: "https://ui.adsabs.harvard.edu/abs/2025AnNuE.21110990T/abstract" },
        { text: "OSTI", url: "https://www.osti.gov/biblio/2503491" },
        // { text: "SSRN", url: "https://papers.ssrn.com/sol3/papers.cfm?abstract_id=4880545" },
        { text: "INL Library", url: "https://inldigitallibrary.inl.gov/sites/STI/STI/Sort_106373.pdf" },
        { text: "World-Nuclear-News", url: "https://www.world-nuclear-news.org/Articles/Idaho-researchers-develop-reactor-digital-twin" },
        { text: "NEI Magazine", url: "https://www.neimagazine.com/news/newsus-researchers-develop-nuclear-reactor-digital-twin-11426524" },
        // { text: "Media 3 (ScienceSprings)", url: "https://sciencesprings.wordpress.com/2023/12/19/from-the-does-idaho-national-laboratory-going-digital-idaho-students-and-engineers-demonstrate-first-nuclear-reactor-digital-twin/" },
        // { text: "Media 4 (ChinaDaily)", url: "https://subsites.chinadaily.com.cn/cnnc/2024-01/04/c_954390.htm" },
        { text: "Power-Eng", url: "https://www.power-eng.com/news/first-digital-twin-of-a-nuclear-reactor/#gref" },
        { text: "NuclearStreet", url: "https://nuclearstreet.com/pro_nuclear_power_blogs/b/world_nuclear_news/archive/2024/01/04/idaho-researchers-develop-reactor-digital-twin" },
        // { text: "Media 7 (Inside.com)", url: "https://inside.com/metaverse/posts/idaho-national-laboratory-and-isu-develop-world-s-first-nuclear-reactor-digital-twin-406722" },
        // { text: "Media 8 (Ground.News)", url: "https://ground.news/article/idaho-researchers-develop-reactor-digital-twin-new-nuclear-world-nuclear-news" }
      ],
    },
    {
      technology: ["Python", "AWS (EC2, S3, Amplify, Cognito, Elastic Beanstalk, CloudWatch, Route 53)", "Large Language Models (LLMs)"],
      slug: "projects/cybrecruiter",
      title: "Cybrecruiter: AI-Driven Hiring in Real Time",
      description: "As Founder & CEO, designed and developed a full-stack, CI/CD, AI-driven recruiting platform on AWS (S3, CloudWatch, Amplify, Route53, Cognito, Lambda), cutting expert decision-making time by ~25% for 8 recruiter beta testers. Integrated WhisperX and GPTo1 for real-time transcription/reasoning. Validated LLM ‘reasoning acceptance’ on 25 question-response samples (~80% agreement with expert feedback).",
      image: "/cybrecruiter.png",
      link: [
        { text: "Website", url: "https://cybrecruiter.com/" }
      ],
    },
    {
      technology: ["Python", "PyTorch", "Reinforcement Learning", "Large Language Models (LLMs)"],
      slug: "projects/decomposing-robotics",
      title: "Decomposing Robotics: Context-Aware Demonstrations for Code as Policies",
      description: "Built a context-aware demonstration decomposition evaluation for Code as Policies in RL Bench, employing large VLMs (Gemini 1.5 Flash, GPT4o) to generate fine-grained, frame-by-frame annotations. Incorporated YOLOv8 and MiDaS to capture gripper velocity, acceleration, and states—improving decomposition accuracy from ~62% to ~98%. Developed an interactive annotation tool for scalable, in-distribution data generation for imitation learning in embodied robotics. [3]",
      image: "/roboticsvlm.jpg",
      link: [
        { text: "Paper", url: "https://www.researchgate.net/publication/388955500_Context_Aware_Demonstration_Decomposition_with_Vision_Language_Models" }
      ],
    },
    {
      technology: ["Python", "LangChain", "Retrieval Augmented Generation (RAG)", "Large Language Models (LLMs)"],
      slug: "projects/infrastructure-llm",
      title: "Infrastructure LLM: Tool-Augmented Real-Time Analysis",
      description: "Conducted a 45–90 minute think-aloud CTA with 8 expert critical infrastructure analysts, translating workflows into an LLM agent architecture. Developed a ground-truth trajectory set mirroring expert actions and enabled dynamic tool usage (aerial imagery labels, RSS feeds, RAG from 8,731 PDF docs, GPT4o image text tool, date/time, calculator, coordinate converter). Empowered site personnel with real-time guidance on infrastructure status, materials, and damage mitigation.",
      image: "/ciai.png",
      link: [
        { text: "Github", url: "https://github.com/EduardoTrevino/Under_Export_Control" }
      ],
    },
    {
      technology: ["Python", "Retrieval Augmented Generation (RAG)", "Large Language Models (LLMs)"],
      slug: "projects/financial-ai",
      title: "Financial AI: GPT4o Agent for Budget Control & Forecasting",
      description: "Performed a contextual inquiry CTA with 3 financial experts managing ~$1.55B in lab projects. Created an LLM agent evaluation set mirroring expert SQL queries, calculators, and workflows. Gathered feedback from 17 users, revealing key pain points. Deployed a Dockerized Django-based LLM agent with Stella embeddings in ChromaDB over 100M+ Oracle rows, enabling prompt-efficient RAG. Now serving 145+ internal users—significantly reducing turnaround times for real-time fiscal queries.",
      image: "/ipl.png",
      link: [
        { text: "Github", url: "https://github.com/EduardoTrevino/Under_Export_Control" }
      ],
    },
    {
      technology: ["Python", "PyTorch", "GANs"],
      slug: "projects/nuclear-imagery-pipeline",
      title: "Nuclear Imagery Pipeline: GAN-Boosted Reactor Classification",
      description: "Developed an automated pipeline aggregating 31GB of nadir imagery (Maxar Goldeye 1, WorldView 2/3) every 21 days across 10 reactor types (BWR, FBR, GCR, HTGR, HWGCR, HWLWR, LWGR, PHWR, PWR, X Energy). Trained an alias-free GAN to generate synthetic imagery, boosting DenseNet161’s reactor classification accuracy by 14%.",
      image: "/gan.png",
      link: [
        { text: "Github", url: "https://github.com/EduardoTrevino/Under_Export_Control" },
        { text: "Paper", url: "https://inldigitallibrary.inl.gov/sites/sti/sti/Sort_61502.pdf" },
        { text: "OSTI", url: "https://www.osti.gov/biblio/1881847" },
        { text: "Poster", url: "https://inldigitallibrary.inl.gov/sites/sti/sti/Sort_62884.pdf" }
      ],
    },
    {
      technology: ["Python", "Scikit-Learn"],
      slug: "projects/truex-digital-twin",
      title: "TRUEX Digital Twin: Rapid Anomaly Detection",
      description: "Developed a digital twin to monitor a TRUEX Extraction Process, detecting anomalies in 21 seconds—significantly faster than conventional optical spectroscopy’s 144-second response.",
      image: "/ADtruex.png",
      link: [
        { text: "NST Open Research", url: "https://nstopenresearch.org/articles/2-69" },
        { text: "ivySCI Article", url: "https://www.ivysci.com/en/articles/8186102__Developing_A_Digital_Twin_of_a_TRUEX_Extraction_Process_that_Enables_Nonproliferation_and_Safeguards_Monitoring_through_Optical_Spectroscopy_and_Machine_Learning" }
      ],
    },
    {
      technology: ["Python", "Cognitive Task Analysis", "A/B Testing", "Large Language Models (LLMs)"],
      slug: "projects/adaptive-llm-learning",
      title: "Adaptive LLM Learning: Think-Aloud Prompt Engineering",
      description: "Conducted a think-aloud CTA with 2 prompt engineering experts (8–17 minutes each) to extract key knowledge components via the KLI framework. Used insights to build an adaptive, LLM-driven learning experience. Ran an A/B test on 35 participants (treatment vs. control) showing significant improvement (p=0.008 via t test, p=0.017 via ANOVA; t stat 2.89, f stat 5.67) in learning outcomes.",
      image: "/promptai.png",
      link: [
        { text: "Paper", url: "https://www.researchgate.net/publication/389033479_Knowledge_Extraction_for_LLM's_using_CTA" }
      ],
    },
    {
      technology: ["Python", "LangChain", "Retrieval Augmented Generation (RAG)", "Large Language Models (LLMs)"],
      slug: "projects/survey-tool-usage-llms",
      title: "Survey on Tool Usage in LLMS: Towards A General Tool Use LLM Framework",
      description: "The advent of Language Model Systems (LLMS) marks a significant evolution in artificial intelligence, where the integration of specialized tools has expanded the capabilities of these models beyond conventional text generation. This study examines tool integration in LLMS, notably how ToolLLM's open-source LLMs, such as LLaMA, are able to employ external APIs to perform complex tasks, a notable advancement over traditional capabilities. By introducing the ToolBench dataset, the framework facilitates an enhanced instruction tuning process for tool use, incorporating a comprehensive collection of APIs, the generation of varied instructions, and the annotation of solution paths. Our investigation confirms the efficacy of ToolLLM through experiments that replicate its findings and through ablation studies that examine the influence of tool integration on LLMS performance. The analysis identifies and proposes solutions to errors within the ToolLLM model.",
      image: "/vha.png",
      link: [
        { text: "Paper", url: "https://www.researchgate.net/publication/388955739_Survey_on_Tool_Usage_in_LLMS_Towards_A_General_Tool_Use_LLM_Framework" },
        { text: "Poster", url: "https://www.researchgate.net/publication/383231851_VHABench_Benchmarking_Underspecified_User_Intents_for_Tool_Augmented_LLMs" }
      ],
    },
    {
      technology: ["Python", "Retrieval Augmented Generation (RAG)", "Large Language Models (LLMs)"],
      slug: "projects/zero-shot-rag",
      title: "Finding the Best Zero-Shot RAG Systems for Multi-Group Topics",
      description: "In this paper we consider the development of a Zero-Shot Retrieval-Augmented Generation system, without any finetuning, that operates via leveraging open-source models. This strategy will prove useful for users aiming to apply RAG in custom domains without substantial budgets, extensive annotation efforts, or deep finetuning expertise. We propose a method, Cluster-RAG, and conduct comparisons with existing state-of-the-art (SOTA) methods. Our findings suggest that Cluster-RAG outperforms traditional re-ranking or context filtering techniques in a zero-shot context. It also exhibits superior performance to systems that utilize retrieval models, such as ColbertV2, which are pretrained specifically for RAG applications. We discuss limitations to this study and conclude the need for more research to determine the true efficacy of the proposed method.",
      image: "/clusterrag.png",
      link: [
        { text: "Github", url: "https://github.com/EduardoTrevino/end-to-end-nlp-rag-from-scratch" },
        { text: "Paper", url: "https://www.researchgate.net/publication/383231819_Finding_the_Best_Zero-Shot_RAG_Systems_for_Multi-Group_Topics" }
      ],
    },
    // {
    //   technology: ["Python", "Pytorch", "Padas", "Sci-kit Learn"],
    //   slug: "projects/SDG-Using-GANs",
    //   title: "Syntetic Data Generation using GANs",
    //   description:
    //     "This AI model was created with Python, Pytorch, Pandas, and Sci-kit Learn. It is real-world application of Thermo-Nuclear Reactor civlian saftey system.",
    //   image: "https://i.imgur.com/26RulSB.jpeg",
    //   link: [
    //     {
    //       text: "Github",
    //       url: "https://github.com/EduardoTrevino/opencv",
    //     },
    //     // {
    //     //   text: "Read More on Medium",
    //     //   url: "https://eduardotrevino.medium.com/",
    //     // },
    //   ],
    // },
    {
      technology: ["Python", "C#", "Unity", "Pytorch", "MongoDB", "Firebase"],
      slug: "projects/LevelUp",
      title: "Level Up",
      description:
        "This application was built using Unity, C#, Python, Pytorch, MongoDB, and Firebase. It takes a single 2D image (selfie of you) and generates a 3D model of yourself to use, modify, and play with in a 3D Virtual World.",
      image: "/vrai.jpg",
      link: [
        {
          text: "Github",
          url: "https://github.com/EduardoTrevino/Project-VR-NPCGPT",
        },
        {
          text: "LinkedIn",
          url: "https://www.linkedin.com/posts/eduardo-trevino_gpt4-chatgpt-openai-activity-7046598326942633984-paS1?utm_source=share&utm_medium=member_desktop&rcm=ACoAADRlrX8BCK_PrI-LabDkQt5R-fWR4Adi4Zs",
        },
      ],
    },
    {
      technology: ["Solidty", "Javascript", "React", "NodeJS", "MongoDB"],
      slug: "projects/BlockchainEcosystem",
      title: "Blockchain Ecosystem",
      description:
        "This application was built using Solidity, Javascript, React, NodeJS, and MongoDB. It is a creative solution that utilizes blockchain technology as a payment processor. The theme of the project revolved around allowing people sharing real estate to pay for eachothers trust in a decentralized manner.",
      image: "/crypto.jpg",
      link: [
        {
          url: "https://github.com/EduardoTrevino/UTSAHack2021CodeQuantumERC-20",
          text: "Github",
        },
        {
          url: "https://inl.gov/integrated-energy/the-proof-is-in-the-software/",
          text: "Media",
        },
        // {
        //   url: "https://eduardotrevino.medium.com/",
        //   text: "Read More on Medium",
        // },
      ],
    },
  ],
};
export default portfolio;
